import { Routes } from "@angular/router";
import { AdminLayoutComponent } from "@shared/components/layouts/admin-layout/admin-layout.component";
import { BlankLayoutComponent } from "@shared/components/layouts/blank-layout/blank-layout.component";
import { authGuard } from "@shared/guards/auth.guard";
import { ReportDashboardComponent } from "@app/views/auth/report/dashboard/report-dashboard.component";
import { ReportPreviewComponent } from "@app/views/auth/report/preview/report-preview.component";
import { ReportDreComponent } from "@app/views/auth/report/dre/report-dre.component";
import { ReportBalanceComponent } from "@app/views/auth/report/balance/report-balance.component";
import { LoginComponent } from "@app/views/public/login/login.component";
import { RedirectComponent } from "@app/views/auth/report/redirect/redirect.component";
import { DevComponent } from "@app/views/dev/dev.component";
import { PdfDashboardComponent } from "@app/views/auth/report/dashboard/pdf/pdf.component";
import { PdfDreComponent } from "@app/views/auth/report/dre/pdf/pdf.component";
import { PdfBalanceComponent } from "@app/views/auth/report/balance/pdf/pdf.component";
import { ReportBudgetComponent } from "./views/auth/report/budget/report-budget.component";
import { PdfBudgetComponent } from "./views/auth/report/budget/pdf/pdf.component";
import { ReportProjectionComponent } from "./views/auth/report/projection/report-projection.component";
import { PdfProjectionComponent } from "./views/auth/report/projection/pdf/pdf.component";

export const routes: Routes = [
    {
        path: "",
        redirectTo: "contabilidades",
        pathMatch: "full"
    },
    {
        path: "dev",
        component: DevComponent
    },
    {
        path: "",
        component: AdminLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: "redirect", component: RedirectComponent },
            { path: "preview", component: ReportPreviewComponent },
            {
                path: "dashboard",
                children: [
                    {
                        path: "",
                        component: ReportDashboardComponent
                    },
                    {
                        path: "pdf",
                        component: PdfDashboardComponent
                    }
                ]
            },
            {
                path: "dre",
                children: [
                    { path: "", component: ReportDreComponent },
                    { path: "pdf", component: PdfDreComponent }
                ]
            },
            {
                path: "balanco",
                children: [
                    { path: "", component: ReportBalanceComponent },
                    { path: "pdf", component: PdfBalanceComponent }
                ]
            },
            {
                path: "orcamento",
                children: [
                    { path: "", component: ReportBudgetComponent },
                    { path: "pdf", component: PdfBudgetComponent }
                ]
            },
            {
                path: "projecao",
                children: [
                    { path: "", component: ReportProjectionComponent },
                    { path: "pdf", component: PdfProjectionComponent }
                ]
            }
        ]
    },
    {
        path: "",
        component: BlankLayoutComponent,
        children: [
            {
                path: "login",
                component: LoginComponent
            }
        ]
    },

    {
        path: "**",
        redirectTo: ""
    }
];
